import React, { useState } from 'react';
import { Form, Button, Alert, Table } from 'react-bootstrap';
import axios from 'axios';

const UploadUsers = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [allowUpdate, setAllowUpdate] = useState(false);
  const [message, setMessage] = useState('');
  const [result, setResult] = useState(null);
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedFile) {
      setMessage('Please select a CSV file to upload');
      return;
    }

    setMessage('File is being uploaded...');
    setResult(null);

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('allowUpdate', allowUpdate ? '1' : '0');

    try {
      const response = await axios.post(`${API_BASE_URL}/users/upload_users.php`, formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        setResult(response.data);
        setMessage('');
      } else {
        setMessage(response.data.message || 'Upload failed.');
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      setMessage('An error occurred while uploading the file.');
    }
  };

  return (
    <div>
      <h2>Upload Users from CSV</h2>
      {message && <Alert variant="info">{message}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formFile">
          <Form.Label>Choose CSV File</Form.Label>
          <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
        </Form.Group>
        <Form.Group controlId="allowUpdate" className="mt-2">
          <Form.Check
            type="checkbox"
            label="Update existing employees (matched by email or IC number)"
            checked={allowUpdate}
            onChange={(e) => setAllowUpdate(e.target.checked)}
          />
          <Form.Text className="text-muted">
            If left unchecked, a row matching an existing employee's email or IC number is skipped rather than modified.
          </Form.Text>
        </Form.Group>
        <div className='mt-2'>
          <p>Download <a href={`${BASE_URL}/assets/list_of_users.csv`}>CSV File template</a> for the users list. Company and Department must match existing names exactly (not IDs).</p>
        </div>
        <Button variant="primary" type="submit" className='mt-2'>
          Upload
        </Button>
      </Form>

      {result && (
        <div className="mt-4">
          <Alert variant="success">
            {result.created} user{result.created === 1 ? '' : 's'} created, {result.updated} updated
            {result.failed.length > 0 && `, ${result.failed.length} row${result.failed.length === 1 ? '' : 's'} skipped`}.
          </Alert>
          {result.failed.length > 0 && (
            <>
              <h5>Skipped Rows</h5>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Row</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {result.failed.map((f, index) => (
                    <tr key={index}>
                      <td>{f.row}</td>
                      <td>{f.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default UploadUsers;
